module.exports = __webpack_public_path__ + "static/qualtrics-2-bcf0f440617efaeffbd505823c5b944e.jpg";